module.exports = __webpack_public_path__ + "img/revenueForecastingBase.2f87fff0.png";